import { MaxSpinner } from "@/components/ui/max-spinner";
import { cn } from "@/lib/utils";

interface LoadingSpinnerProps {
  className?: string;
  size?: "sm" | "md" | "lg";
}

export function LoadingSpinner({ className, size = "md" }: LoadingSpinnerProps) {
  return (
    <div className="flex items-center justify-center">
      <MaxSpinner 
        size={size}
        className={cn("", className)} 
      />
    </div>
  );
}